import { CheckIcon } from "lucide-react";

interface PathIconProps {
  isPathCompleted: boolean;
  isPathActive: boolean;
  isPathInProgress: boolean;
  isPathHidden: boolean;
}

export const PathIcon = ({
  isPathCompleted,
  isPathActive,
  isPathInProgress,
  isPathHidden,
}: PathIconProps) => {
  if (isPathCompleted) {
    return (
      <div className="flex h-4 w-4 items-center justify-center rounded-full bg-teal-500">
        <CheckIcon size={10} className="text-white" />
      </div>
    );
  }

  if (isPathActive) {
    return (
      <div className="flex h-[24px] w-[24px] items-center justify-center rounded-full bg-white ring-[3px] ring-[#dde0ff]">
        <div className="bg-remedium-blue h-[16px] w-[16px] rounded-full" />
      </div>
    );
  }

  if (isPathInProgress) {
    return (
      <div className="flex h-4 w-4 items-center justify-center rounded-full bg-white">
        <div className="bg-remedium-blue h-[16px] w-[16px] rounded-full" />
      </div>
    );
  }

  if (isPathHidden) {
    return (
      <div className="flex h-4 w-4 items-center justify-center rounded-full border border-dashed border-zinc-300 bg-white">
        <div className="h-1 w-1 rounded-full bg-zinc-300" />
      </div>
    );
  }

  return (
    <div className="flex h-4 w-4 items-center justify-center rounded-full border border-zinc-500 bg-white">
      <div className="h-1 w-1 rounded-full bg-zinc-500" />
    </div>
  );
};
